import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, UsersResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }
        this.st = new SmartTable();
        this.translateKey = (type) => ({
            AD: 'sp-account-type.active-directory',
            EXTERNAL_EMAIL: 'sp-account-type.external-email',
            INTERNAL_EMAIL: 'sp-account-type.internal-email',
            PHONENUMBER: 'sp-account-type.phone-number',
            SHARED_EMAIL: 'sp-account-type.shared-email',
            SIMPLE_USERNAME: 'sp-account-type.simple-username',
        })[type];
    }
    search() {

        this.spAlert = null;
        this.selectedCompanyUser = null;
        this.isSearching = true;

        this.UsersResource
            .getCompanyUserForSaaspassUser(this.companyId,this.searchText)
            .then((companyUser) => this.selectedCompanyUser = companyUser)
            .catch((response) => {
                if (response.status === 404) {
                    this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            })
            .finally(() => this.isSearching = false);
    }

    move() {
        const accountIds = this.accounts
            .filter(({isDisownable}) => isDisownable)
            .map(({id}) => id);
        this.isSaving = true;

        if (accountIds.length == 0){
            this.Alert('success', 'company.user-directories.manage-user.move-accounts.nothingTomoved');
            this.$state.go('company.user-directories.saaspass-users');
        }
        else{

        this.AccountsResource.bulkMoveCompanyUserAccount(this.companyId,this.companyUser.id,this.selectedCompanyUser,accountIds)
            .then(() => {
                const accounts = this.accountsForCompanyUser;
                const filteredAccounts = accounts.filter(({id}) => !accountIds.includes(id));
                accounts.splice(0, accounts.length, ...filteredAccounts);

                if (accounts.length) {
                    this.$state.go('^', {}, {reload: '^'});
                } else {
                    this.$state.go('company.user-directories.saaspass-users');
                }
                this.Alert('success', 'company.user-directories.manage-user.move-accounts.moved');
            })
            .finally(() => this.isSaving = false)
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/move-accounts/move-accounts.controller.js